// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DQ-z","inlineTitle":"EQ-z","sponsoredAdsWrapper":"FQ-z","marketplaceRecosWrapper":"GQ-z"};